class TextSlider {
  constructor(rootEl) {
    this.root = rootEl;
    this.viewport = this.root.querySelector('.text-slider__viewport');
    this.track = this.root.querySelector('.text-slider__track');
    this.prevBtn = this.root.querySelector('.text-slider__prev');
    this.nextBtn = this.root.querySelector('.text-slider__next');
    this.currentIndex = 0;

    if (!this.viewport || !this.track || !this.prevBtn || !this.nextBtn) {
        return;
    }

    this.slides = Array.from(this.track.querySelectorAll('.text-slider__slide'));

    if (this.slides.length === 3) {
        this.root.classList.add('has-three-slides');
    }
    
    if (this.slides.length <= 1) {
        this.prevBtn.style.display = 'none';
        this.nextBtn.style.display = 'none';
        return;
    }

    this.init();
  }

  init() {
    this.setWidths();
    this.updateButtons();
    this.attachEvents();
    this.goToSlide(this.currentIndex, false);
    window.addEventListener('resize', () => this.onResize());
  }

  getSlidesPerView(width) {
    const currentWidth = width || window.innerWidth;
    if (currentWidth >= 1200) {
        return 4;
    } else if (currentWidth >= 768) {
        return 2;
    } else {
        return 1;
    }
  }

  setWidths() {
    const slidesPerView = this.getSlidesPerView();
    
    this.slideWidth = this.viewport.offsetWidth / slidesPerView;
    this.track.style.width = `${this.slideWidth * this.slides.length}px`;
    this.slides.forEach(slide => {
      slide.style.width = `${this.slideWidth}px`;
      slide.style.height = '';
    });
    
    if (slidesPerView > 1) {
        let maxHeight = 0;
        this.slides.forEach(slide => {
            slide.style.width = '100%'; 
            maxHeight = Math.max(maxHeight, slide.offsetHeight);
            slide.style.width = `${this.slideWidth}px`;
        });
        this.viewport.style.height = `${maxHeight}px`;
        this.track.style.height = `${maxHeight}px`;
    } else {
        this.viewport.style.height = ''; 
        this.track.style.height = '';
    }
  }

  attachEvents() {
    this.prevBtn.addEventListener('click', () => this.goToSlide(this.currentIndex - 1));
    this.nextBtn.addEventListener('click', () => this.goToSlide(this.currentIndex + 1));
  }

  onResize() {
    if (this.slides.length <= 1) {
        this.prevBtn.style.display = 'none';
        this.nextBtn.style.display = 'none';
    } else {
        this.prevBtn.style.display = ''; 
        this.nextBtn.style.display = '';
    }
    this.setWidths();
    this.goToSlide(this.currentIndex, false);
  }

  goToSlide(index, animate = true) {
    
    let newIndex = index;
    const lastScrollableIndex = this.slides.length - this.getSlidesPerView();
    
    if (newIndex < 0) {
        newIndex = 0;
    } else if (newIndex > lastScrollableIndex) {
        newIndex = lastScrollableIndex < 0 ? 0 : lastScrollableIndex;
    }
    
    this.currentIndex = newIndex;

    const offset = -newIndex * this.slideWidth;
    this.track.style.transition = animate ? 'transform 0.4s ease' : 'none';
    this.track.style.transform = `translateX(${offset}px)`;

    this.updateButtons();
  }

  updateButtons() {
    this.prevBtn.disabled = this.currentIndex === 0;
    this.nextBtn.disabled = this.currentIndex >= this.slides.length - this.getSlidesPerView();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-text-slider]').forEach(el => new TextSlider(el));
});

export default TextSlider;